/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Election } from '../../models/election';

export interface GetActiveElections$Params {
}

export function getActiveElections(http: HttpClient, rootUrl: string, params?: GetActiveElections$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Election>>> {
  const rb = new RequestBuilder(rootUrl, getActiveElections.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Election>>;
    })
  );
}

getActiveElections.PATH = '/election/active';
